import Pointer from './pointer.js';

class Mouse2DPointer extends Pointer {
    constructor(getDomObject) {
        super();

        this._getDomObject = getDomObject;

        this._container = null;
        this._position = null;
        this._mouseDownObject = null;

        this._eventDownThis = this._eventDown.bind(this);
        this._eventUpThis = this._eventUp.bind(this);
        this._eventMoveThis = this._eventMove.bind(this);
    }

    init() {
        this._container = document.getElementById('slide-layers-container');
        this._letterbox = Q3.editMode ? document.getElementById('slide-layers-container') : document.getElementById('slide-layers-letterbox');
        this._position = {};

        window.addEventListener('mousedown', this._eventDownThis);
        window.addEventListener('mouseup', this._eventUpThis);
        window.addEventListener('mousemove', this._eventMoveThis);
        window.addEventListener('touchstart', this._eventDownThis);
        window.addEventListener('touchend', this._eventUpThis);
        window.addEventListener('touchmove', this._eventMoveThis);
    }

    uninit() {
        window.removeEventListener('mousedown', this._eventDownThis);
        window.removeEventListener('mouseup', this._eventUpThis);
        window.removeEventListener('mousemove', this._eventMoveThis);
        window.removeEventListener('touchstart', this._eventDownThis);
        window.removeEventListener('touchend', this._eventUpThis);
        window.removeEventListener('touchmove', this._eventMoveThis);

        this._container = null;
        this._letterbox = null;
        this._position = null;
        this._mouseDownObject = null;
    }

    get position() {
        return this._position;
    }

    _eventDown(e) {
        e = e.changedTouches ? e.changedTouches[0] : e;
        let object = this._getDomObject(e.target);
        this._mouseDownObject = object;
        let position = this._getMousePosition(e, {});

        Object.assign(this._position, position);

        this.downEvent.fire({ position, object });
    }

    _eventUp(e) {
        e = e.changedTouches ? e.changedTouches[0] : e;
        let position = this._getMousePosition(e, {});

        Object.assign(this._position, position);

        this.upEvent.fire({ position });
    }

    _eventMove(e) {
        e = e.changedTouches ? e.changedTouches[0] : e;
        let position = this._getMousePosition(e, {});

        Object.assign(this._position, position);

        this.moveEvent.fire({ position });
    }

    _getMousePosition(e, position) {
        e = e.changedTouches ? e.changedTouches[0] : e;
        let { clientX, clientY } = e;

        let { left, top, width, height } = this[this._mouseDownObject && this._mouseDownObject._object.inLetterbox ? "_letterbox" : "_container"].getBoundingClientRect();

        position.x = (clientX-left)/width;
        position.y = (clientY-top)/height;

        return position;
    }
}

export default Mouse2DPointer;
